import testMediaBreakpoints from 'root/src/client/logic/app/thunks/testMediaBreakpoints'

export default (dispatch) => {
	if (global.window) {
		window.onresize = () => {
			dispatch(testMediaBreakpoints())
		}
	}
}
